import { Box, Grid, Link, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormAssets } from './financials/FormAssets';
import { FormLiabilities } from './financials/FormLiabilities';
import TermsDialog from './TermsDialog';
import { CheckBoxCustom } from './ui/CheckboxCustom';
import { FormEmployments } from './financials/FormEmployments';
import { TextFieldCustom } from './ui/TextFieldCustom';
import SelectFieldCustom from './ui/SelectFieldCustom';
export default function FormEmployment(props) {
    const { t, i18n } = useTranslation();
    const { control, unregister } = useFormContext();
    const { fields: applicantsFields } = useFieldArray({
        control,
        name: 'applicants'
    });
    const [state, setState] = React.useState({
        checkedAgree: false
    });

    const handleChangeAgree = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };

    const [openTermsDialog, setOpenTermsDialog] = React.useState(false);

    const { branches, Disclaimer = '', DisclaimerFr = '' } = props.data;

    useEffect(() => {
        if (branches == null || branches.length === 0) unregister('loan.branch');
    }, [branches]);

    return (
        <div>
            {applicantsFields.map((applicant, indexApp) => {
                return (
                    <div key={applicant.id}>
                        <FormEmployments indexApp={indexApp} data={props.data} />
                        <br />
                        <FormAssets indexApp={indexApp} data={props.data} />
                        <br />
                        <br />
                        <FormLiabilities indexApp={indexApp} data={props.data} />
                    </div>
                );
            })}
            <br />
            <br />
            {branches?.length > 0 ? (
                <div>
                    <Typography component="div">
                        <Box fontWeight="fontWeightMedium" pb={2} color="primary.main">
                            {t('branchTitle')}
                        </Box>
                    </Typography>
                    <Grid container spacing={3}>
                        <Grid item md={6} xs={12}>
                            <SelectFieldCustom
                                name="loan.branch"
                                label={t('loanLabels.branch')}
                                items={branches}
                            />
                        </Grid>
                    </Grid>
                </div>
            ) : null}

            <br />
            <br />
            <Typography component="div">
                <Box fontWeight="fontWeightMedium" pb={2} color="primary.main">
                    {t('optionalCommentLabel')}
                </Box>
            </Typography>
            <TextFieldCustom
                name="loan.comment"
                placeholder={t('optionalCommentPlaceholder')}
                multiline
                rows={3}
                inputProps={{ maxLength: 320 }}
            />
            <br />
            <br />
            <br />
            <CheckBoxCustom
                name="checkedAgree"
                onChange={handleChangeAgree}
                label={
                    <div>
                        <span>{t('agree.checkboxText')}</span>{' '}
                        <Link
                            onClick={(e) => {
                                e.preventDefault();
                                setOpenTermsDialog(true);
                            }}>
                            {t('agree.terms')}
                        </Link>
                    </div>
                }
                defaultValue={false}
            />
            <TermsDialog
                text={(i18n.language === 'fr' && DisclaimerFr !== '') ? DisclaimerFr : Disclaimer}
                open={openTermsDialog}
                onClose={() => {
                    setOpenTermsDialog(false);
                }}
            />
        </div>
    );
}
